import { Injectable, inject } from "@angular/core";
import { Resolve, Router } from "@angular/router";
import { MatidorAdminService } from "./matidor-admin/matidor-admin.service";

@Injectable({ providedIn: 'root' })
export class MatidorAdminResolve implements Resolve<any> {
  private readonly _matidorAdminService = inject(MatidorAdminService);
  private readonly _router = inject(Router);

  resolve(): Promise<any> {
    return new Promise(async (resolve) => {
      try {
        const user = this._matidorAdminService.user();

        if (user == null) {
          await this._matidorAdminService.getCurrentUser();
        }

        resolve({});
      } catch (error) {
        resolve({});
      }
    });
  }
}
